import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const MobileQuickActions = ({ onShare, onExport, onSettings }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = [
    {
      id: 'share',
      icon: 'Share2',
      label: 'Share',
      onClick: onShare,
      color: 'var(--color-primary)'
    },
    {
      id: 'export',
      icon: 'Download',
      label: 'Export',
      onClick: onExport,
      color: 'var(--color-secondary)'
    },
    {
      id: 'settings',
      icon: 'Settings',
      label: 'Settings',
      onClick: onSettings,
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div
        className={`flex flex-col-reverse gap-3 mb-3 transition-all duration-300 ${
          isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => {
              action?.onClick();
              setIsExpanded(false);
            }}
            className="flex items-center gap-3 bg-card border border-border rounded-full shadow-lg px-4 py-3 transition-all duration-300 hover:scale-105 active:scale-95"
          >
            <Icon name={action?.icon} size={20} color={action?.color} />
            <span className="text-sm font-medium text-foreground whitespace-nowrap">
              {action?.label}
            </span>
          </button>
        ))}
      </div>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-14 h-14 bg-primary rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95"
        aria-label="Toggle quick actions"
      >
        <Icon
          name={isExpanded ? 'X' : 'Menu'}
          size={24}
          color="var(--color-primary-foreground)"
        />
      </button>
    </div>
  );
};

export default MobileQuickActions;